import request from '@/utils/request'

const pre = '/education/question/library'

// 根据单词ID分页查询知识库
export function reqPageByWord(params) {
    return request({
        url: pre + '/pageByWord',
        method: 'get',
        params
    })
}

// 统计某个单词各题型的题目数量
export function reqStatsByWord(wordId) {
    return request({
        url: pre + '/statsByWord',
        method: 'get',
        params: { wordId }
    })
}

// 删除题目
export function reqDeleteQuestion(id) {
    return request({
        url: pre + '/delete',
        method: 'post',
        params: { id }
    })
}

// 查询题目详情
export function reqQuestionDetail(id) {
    return request({
        url: pre + '/detail',
        method: 'get',
        params: { id }
    })
}

// 题库中心通用分页（题型/诊断状态/状态/重复标记筛选）
export function reqLibraryPage(params) {
    return request({
        url: pre + '/page',
        method: 'get',
        params
    })
}

// 智能选题组卷：按目标单词池 + 题型检索候选（命中数降序）
export function reqSelectForManualPaper(wordIds, questionType) {
    return request({
        url: pre + '/selectForManualPaper',
        method: 'post',
        data: { wordIds, questionType }
    })
}

// 老师二次诊断确认
export function reqConfirmTeacherReview(id) {
    return request({
        url: pre + '/confirmTeacherReview',
        method: 'post',
        params: { id }
    })
}

// 撤销老师诊断（误操作时退回 AI 已诊断状态）
export function reqRevokeTeacherReview(id) {
    return request({
        url: pre + '/revokeTeacherReview',
        method: 'post',
        params: { id }
    })
}

// 重复确认处理 discard-废弃 / restore-恢复启用
export function reqResolveDuplicate(id, action) {
    return request({
        url: pre + '/resolveDuplicate',
        method: 'post',
        params: { id, action }
    })
}

// 手动 AI 重新诊断
export function reqReDiagnose(id) {
    return request({
        url: '/education/question/clean/reDiagnose',
        method: 'post',
        params: { id },
        timeout: 120000
    })
}

// 全局清洗进度统计（按当前租户，与选中单元无关）
export function reqStatsGlobal() {
    return request({
        url: pre + '/statsGlobal',
        method: 'get'
    })
}

// 单元级清洗状态统计
export function reqStatsReviewByUnit(params) {
    return request({
        url: pre + '/statsReviewByUnit',
        method: 'get',
        params
    })
}

// 单词级清洗状态批量统计（wordIds 传逗号分隔字符串，后端按逗号解析）
export function reqStatsReviewByWords(wordIds) {
    const ids = Array.isArray(wordIds) ? wordIds.join(',') : wordIds
    return request({
        url: pre + '/statsReviewByWords',
        method: 'get',
        params: { wordIds: ids }
    })
}

// 批量统计多个单词各题型的题目数量（替代逐词串行调用 statsByWord）
export function reqStatsByWordIdsBatch(wordIds) {
    return request({
        url: pre + '/statsByWordIdsBatch',
        method: 'get',
        params: { wordIds }
    })
}

// 手动补齐生成：为指定单词池 + 题型，调副AI生成指定数量题目并入库
export function reqGenerateForCombo(wordIds, questionType, count) {
    return request({
        url: pre + '/generateForCombo',
        method: 'post',
        data: { wordIds, questionType, count },
        timeout: 180000
    })
}

// 单单词补齐失败跳过：分页查询被标记跳过的(单词,题型)
export function reqGenerateFailPage(params) {
    return request({
        url: '/education/question/generate/fail/page',
        method: 'get',
        params
    })
}

// 单单词补齐失败跳过：手动解除（解除后该(单词,题型)恢复参与补齐）
export function reqGenerateFailReset(wordId, questionType) {
    return request({
        url: '/education/question/generate/fail/reset',
        method: 'post',
        params: { wordId, questionType }
    })
}

// 组合题型下钻：年级→分册层级（含各组单词组数）
export function reqComboTree(params) {
    return request({
        url: pre + '/comboTree',
        method: 'get',
        params
    })
}

// 组合题型下钻：分页列出某题型的"单词组"(combo_key) 列表（含覆盖单词中文释义）
export function reqComboKeys(params) {
    return request({
        url: pre + '/comboKeys',
        method: 'get',
        params
    })
}

// 组合题型下钻：按 combo_key + 题型 分页查询试题列表（只读）
export function reqPageByCombo(params) {
    return request({
        url: pre + '/pageByCombo',
        method: 'get',
        params
    })
}

